/* =================== DEPOIMENTOS =================== */
$(function () {
  const slideItems = $(".carrosel-depoimentos .depoimento-wrp").length;
  const slideDots = slideItems > 3;
  $(".carrosel-depoimentos").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    arrows: false,
    dots: slideDots,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          dots: slideItems > 2,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          dots: slideItems > 1,
        },
      },
    ],
  });
});
